// src/components/sections/HomeGlobalLeaders.jsx
import React, { useRef } from 'react'
import { motion as Motion, useInView } from 'framer-motion'
import './HomeGlobalLeaders.scss'

export default function HomeGlobalLeaders({ sectionData }) {
    const sectionRef = useRef(null)
    const isInView = useInView(sectionRef, { amount: 0.3, once: false })

    if (!sectionData) {
        // Skeleton state
        return (
            <section className="brand-section" ref={sectionRef}>
                <p className="brand-text animate-pulse">
                    {/* placeholder heading */}
                </p>
                <div className="brand-logos">
                    {[...Array(6)].map((_, i) => (
                        <div key={i} className="logo-wrapper">
                            <div className="h-10 w-40 bg-[#1f1f1f] rounded-md animate-pulse" />
                        </div>
                    ))}
                </div>
            </section>
        )
    }

    const { heading, leaders = [] } = sectionData

    if (!leaders.length) return null

    const logoVariants = {
        hidden: { opacity: 0, y: 40 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.15, duration: 0.6, ease: 'easeOut' },
        }),
    }

    return (
        <section className="brand-section" ref={sectionRef}>
            {heading && (
                <Motion.h2
                    className="brand-text"
                    initial="hidden"
                    animate={isInView ? 'visible' : 'hidden'}
                    variants={logoVariants}
                >
                    {heading}
                </Motion.h2>
            )}

            <div className="brand-logos">
                {leaders.map((leader, i) => (
                    <Motion.div
                        key={leader.id || leader._id || leader.nameOrAlt || i}
                        className="logo-wrapper"
                        custom={i}
                        variants={logoVariants}
                        initial="hidden"
                        animate={isInView ? 'visible' : 'hidden'}
                    >
                        <img
                            src={leader.imageUrl}
                            alt={leader.nameOrAlt || `Brand logo ${i + 1}`}
                        />
                    </Motion.div>
                ))}
            </div>
        </section>
    )
}
